import { CircularProgress } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import humanFileSize from '../../constants/coreConstants'
import { getFileToByteArray } from '../../utils/File'
import { bindParams } from '../../utils/Link'
import Form from '../Form/Form'
import FormButtonIcon from '../Form/FormButtonIcon'
import FormIcon from '../Form/FormIcon'
import InputFile from '../Form/input/InputFile'
import SlidingForm from '../Form/SlidingForm'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
	button: {
		backgroundColor: theme.palette.secondary.main,
		borderColor: theme.palette.primary.main,
		color: theme.palette.primary.main,
	},
	rightIcon: {
		marginLeft: theme.spacing.unit,
		color: theme.palette.primary.main,
	},
	iconSmall: {
		fontSize: 20,
	},
	typographyRoot: {
		color: 'white',
		fontSize: 17,
		marginTop: 20,
		marginBottom: 15,
	},
	progress: {
		display: 'inline-block',
		verticalAlign: 'middle',
	},
	progressLabel: {
		color: theme.palette.primary.main,
		display: 'inline-block',
		marginLeft: 10,
	},
	progressBlock: {
		margin: 10,
	},
	charactersAllowed: {
		margin: '20px 0',
		color: '#fff',
	},
}))

function OtherFilesInformationForm({ open, close, data }) {
	const { t } = useTranslation(['user'])
	const classes = useStyles()
	const [file, setFile] = useState(null)
	const [loader] = useState(false)
	const { enqueueSnackbar } = useSnackbar()

	const onFormSubmit = () => {
		if (file) upload(file)
	}

	const upload = (fileToUpload) => {
		getFileToByteArray(fileToUpload, function (res, cberror = null) {
			if (!cberror) {
				data(res)
				close()
			} else {
				enqueueSnackbar(bindParams(t(cberror.error), humanFileSize), { variant: 'error' })
			}
		})
	}

	return (
		<SlidingForm
			direction="vertical"
			open={open}
			title={t('OtherFiles')}
			iconAttachement={
				<>
					<FormIcon icon="clear" onClick={close} />
				</>
			}
			submitLabel="Valider"
			onClose={close}
		>
			<Form onSubmit={onFormSubmit}>
				<Typography
					component="p"
					classes={{
						root: classes.typographyRoot,
					}}
				>
					{t('joinFile')}
					<Typography component="span" className={classes.charactersAllowed}>
						{t('file_characters_allowed')}
					</Typography>
				</Typography>
				<InputFile label={t('upload')} name="upload" setFile={setFile} />
				{loader && (
					<>
						<div className={classes.progressBlock}>
							<CircularProgress className={classes.progress} color="primary" />
							<Typography className={classes.progressLabel}>{t('UploadInProgress')}</Typography>
						</div>
					</>
				)}
				<FormButtonIcon type="submit" />
			</Form>
		</SlidingForm>
	)
}
OtherFilesInformationForm.propTypes = {
	open: PropTypes.bool,
	close: PropTypes.func,
	data: PropTypes.func,
}
export default OtherFilesInformationForm
